import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { apiFetch } from '../../hooks/useApi';
import {
  CurrencyIcon, UsersIcon, PackageIcon, ReceiptIcon,
  TrendUpIcon, AlertIcon, CheckIcon, ClockIcon,
  ArrowRightIcon, RefreshIcon, ZapIcon, ShieldIcon
} from '../../components/Icons';

export default function AdminOverview() {
  const navigate = useNavigate();
  const [stats,   setStats]   = useState(null);
  const [load,    setLoad]    = useState(true);

  useEffect(() => { carregar(); }, []);

  const carregar = async () => {
    setLoad(true);
    try {
      const [anuncios, utilizadores] = await Promise.all([
        apiFetch('/admin/anuncios/todos').catch(()=>({anuncios:[]})),
        apiFetch('/admin/utilizadores').catch(()=>({utilizadores:[]})),
      ]);
      const an   = anuncios.anuncios   || [];
      const ut   = utilizadores.utilizadores || [];
      setStats({
        totalAnuncios:   an.length,
        anunciosPendentes: an.filter(a=>a.estado==='pendente').length,
        anunciosAtivos:  an.filter(a=>a.estado==='ativo').length,
        totalUtilizadores: ut.length,
        clientes:        ut.filter(u=>u.tipo==='cliente').length,
        fornecedores:    ut.filter(u=>u.tipo==='fornecedor').length,
        kycPendentes:    ut.filter(u=>u.kyc_estado==='pendente' && u.tipo!=='admin').length,
        anunciosRecentes: an.slice(0,5),
        utilizadoresRecentes: ut.slice(0,5),
      });
    } catch(e) {
      setStats({ totalAnuncios:0, anunciosPendentes:0, anunciosAtivos:0, totalUtilizadores:0, clientes:0, fornecedores:0, kycPendentes:0, anunciosRecentes:[], utilizadoresRecentes:[] });
    } finally { setLoad(false); }
  };

  const s = stats || {};

  const cards = [
    { icon:<CurrencyIcon/>, label:'GMV Total', value:'0 Kz', delta:'+0%', bg:'#FFF7ED', ic:'#F97316', sub:'Em desenvolvimento' },
    { icon:<UsersIcon/>,    label:'Utilizadores', value: load?'…':s.totalUtilizadores||0, delta:`${s.clientes||0} clientes`, bg:'#EFF6FF', ic:'#2563EB', sub:`${s.fornecedores||0} fornecedores` },
    { icon:<PackageIcon/>,  label:'Anúncios',   value: load?'…':s.totalAnuncios||0, delta:`${s.anunciosAtivos||0} activos`, bg:'#F0FDF4', ic:'#16A34A', sub:`${s.anunciosPendentes||0} pendentes` },
    { icon:<ShieldIcon/>,   label:'KYC Pendentes', value: load?'…':s.kycPendentes||0, delta:'A verificar', bg:'#FFFBEB', ic:'#D97706', sub:'Documentos submetidos', alert: (s.kycPendentes||0)>0 },
  ];

  return (
    <>
      <div className="topbar">
        <div>
          <div className="topbar-title">Painel de Controlo</div>
          <div className="topbar-sub">Visão geral da plataforma KiAluga</div>
        </div>
        <div className="topbar-actions">
          <button className="btn btn-outline" onClick={carregar} style={{display:'flex',alignItems:'center',gap:'6px'}}>
            <RefreshIcon size={14}/> Actualizar
          </button>
        </div>
      </div>

      <div className="page-content">
        {/* Alerta pendentes */}
        {(s.anunciosPendentes>0 || s.kycPendentes>0) && (
          <div style={{background:'#FFFBEB',border:'1px solid #FDE68A',borderRadius:'10px',padding:'12px 16px',marginBottom:'18px',display:'flex',alignItems:'center',gap:'10px',fontSize:'13px'}}>
            <AlertIcon size={16} color='#D97706'/>
            <span style={{color:'#92400E',fontWeight:'500'}}>
              {s.anunciosPendentes>0 && `${s.anunciosPendentes} anúncio(s) pendente(s) de aprovação`}
              {s.anunciosPendentes>0 && s.kycPendentes>0 && ' · '}
              {s.kycPendentes>0 && `${s.kycPendentes} verificação(ões) KYC a rever`}
            </span>
            <button className="btn btn-sm" style={{marginLeft:'auto',background:'#D97706',color:'#fff',border:'none'}}
              onClick={()=>navigate('/admin/anuncios')}>Ver agora <ArrowRightIcon size={12}/></button>
          </div>
        )}

        {/* Stats */}
        <div className="stats-grid" style={{marginBottom:'20px'}}>
          {cards.map((c,i)=>(
            <div key={i} className="stat-card" style={{position:'relative',overflow:'hidden'}}>
              <div style={{display:'flex',alignItems:'flex-start',justifyContent:'space-between'}}>
                <div className="stat-icon" style={{background:c.bg,color:c.ic}}>
                  {React.cloneElement(c.icon,{size:18,color:c.ic})}
                </div>
                {c.alert && <span style={{width:'8px',height:'8px',borderRadius:'50%',background:'#F97316',flexShrink:0,marginTop:'4px'}}></span>}
              </div>
              <div className="stat-value" style={{marginTop:'8px'}}>{c.value}</div>
              <div className="stat-label">{c.label}</div>
              <div style={{fontSize:'11px',color:'var(--text-muted)',marginTop:'2px'}}>{c.delta} · {c.sub}</div>
            </div>
          ))}
        </div>

        <div className="grid-2">
          {/* Anúncios recentes */}
          <div className="card">
            <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',marginBottom:'14px'}}>
              <div style={{display:'flex',alignItems:'center',gap:'8px'}}>
                <PackageIcon size={15} color='var(--orange)'/>
                <span style={{fontSize:'13px',fontWeight:'600'}}>Anúncios recentes</span>
              </div>
              <button className="btn btn-ghost btn-sm" onClick={()=>navigate('/admin/anuncios')} style={{display:'flex',alignItems:'center',gap:'4px',fontSize:'11px'}}>
                Ver todos <ArrowRightIcon size={12}/>
              </button>
            </div>
            {load ? (
              <div style={{textAlign:'center',padding:'30px',color:'var(--text-muted)',fontSize:'13px'}}>A carregar...</div>
            ) : s.anunciosRecentes?.length === 0 ? (
              <div style={{textAlign:'center',padding:'30px',color:'var(--text-muted)'}}>
                <PackageIcon size={28} color='var(--border)'/><br/>
                <span style={{fontSize:'13px',marginTop:'8px',display:'block'}}>Sem anúncios ainda</span>
              </div>
            ) : s.anunciosRecentes?.map((a,i)=>(
              <div key={i} style={{display:'flex',alignItems:'center',gap:'10px',padding:'8px 0',borderBottom: i<s.anunciosRecentes.length-1?'1px solid var(--border)':'none'}}>
                <div style={{width:'36px',height:'36px',borderRadius:'8px',background:'linear-gradient(135deg,#fde8d8,#fed7b0)',display:'flex',alignItems:'center',justifyContent:'center',overflow:'hidden',flexShrink:0}}>
                  {a.fotos?.[0]
                    ? <img src={a.fotos[0]} alt="" style={{width:'100%',height:'100%',objectFit:'cover'}} onError={e=>e.target.style.display='none'}/>
                    : <PackageIcon size={16} color='#F97316'/>
                  }
                </div>
                <div style={{flex:1,minWidth:0}}>
                  <div style={{fontSize:'12px',fontWeight:'600',overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{a.titulo}</div>
                  <div style={{fontSize:'11px',color:'var(--text-muted)'}}>{a.fornecedor_nome||'—'}</div>
                </div>
                <span className={`badge badge-${a.estado==='ativo'?'success':a.estado==='pendente'?'warning':a.estado==='rejeitado'?'danger':'neutral'}`}>
                  {a.estado==='ativo'?'Activo':a.estado==='pendente'?'Pendente':a.estado==='rejeitado'?'Rejeitado':'Pausado'}
                </span>
              </div>
            ))}
          </div>

          {/* Utilizadores recentes */}
          <div className="card">
            <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',marginBottom:'14px'}}>
              <div style={{display:'flex',alignItems:'center',gap:'8px'}}>
                <UsersIcon size={15} color='var(--orange)'/>
                <span style={{fontSize:'13px',fontWeight:'600'}}>Utilizadores recentes</span>
              </div>
              <button className="btn btn-ghost btn-sm" onClick={()=>navigate('/admin/utilizadores')} style={{display:'flex',alignItems:'center',gap:'4px',fontSize:'11px'}}>
                Ver todos <ArrowRightIcon size={12}/>
              </button>
            </div>
            {load ? (
              <div style={{textAlign:'center',padding:'30px',color:'var(--text-muted)',fontSize:'13px'}}>A carregar...</div>
            ) : s.utilizadoresRecentes?.length === 0 ? (
              <div style={{textAlign:'center',padding:'30px',color:'var(--text-muted)'}}>
                <UsersIcon size={28} color='var(--border)'/><br/>
                <span style={{fontSize:'13px',marginTop:'8px',display:'block'}}>Sem utilizadores ainda</span>
              </div>
            ) : s.utilizadoresRecentes?.map((u,i)=>(
              <div key={i} style={{display:'flex',alignItems:'center',gap:'10px',padding:'8px 0',borderBottom: i<s.utilizadoresRecentes.length-1?'1px solid var(--border)':'none'}}>
                <div style={{width:'34px',height:'34px',borderRadius:'50%',background:'var(--orange)',display:'flex',alignItems:'center',justifyContent:'center',fontSize:'13px',fontWeight:'700',color:'#fff',flexShrink:0,overflow:'hidden'}}>
                  {u.foto_url ? <img src={u.foto_url} alt="" style={{width:'100%',height:'100%',objectFit:'cover'}} onError={e=>e.target.style.display='none'}/> : (u.nome||'?')[0].toUpperCase()}
                </div>
                <div style={{flex:1,minWidth:0}}>
                  <div style={{fontSize:'12px',fontWeight:'600',overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{u.nome||u.email||'Sem nome'}</div>
                  <div style={{fontSize:'11px',color:'var(--text-muted)',textTransform:'capitalize'}}>{u.tipo}</div>
                </div>
                <span className={`badge badge-${u.kyc_estado==='verificado'?'success':u.kyc_estado==='rejeitado'?'danger':'warning'}`}>
                  {u.kyc_estado==='verificado'?'Verificado':u.kyc_estado==='rejeitado'?'Rejeitado':'Pendente'}
                </span>
              </div>
            ))}
          </div>
        </div>

        {/* Acções rápidas */}
        <div className="card" style={{marginTop:'16px'}}>
          <div style={{display:'flex',alignItems:'center',gap:'8px',marginBottom:'14px'}}>
            <ZapIcon size={15} color='var(--orange)'/>
            <span style={{fontSize:'13px',fontWeight:'600'}}>Acções rápidas</span>
          </div>
          <div className="grid-4">
            {[
              { icon:<PackageIcon size={20} color='#F97316'/>, label:'Moderar anúncios', sub:`${s.anunciosPendentes||0} pendentes`, path:'/admin/anuncios', bg:'#FFF7ED' },
              { icon:<UsersIcon size={20} color='#2563EB'/>,   label:'Gerir utilizadores', sub:`${s.totalUtilizadores||0} registados`, path:'/admin/utilizadores', bg:'#EFF6FF' },
              { icon:<ReceiptIcon size={20} color='#16A34A'/>, label:'Ver transações', sub:'Histórico completo', path:'/admin/transacoes', bg:'#F0FDF4' },
              { icon:<AlertIcon size={20} color='#D97706'/>,   label:'Disputas abertas', sub:'Resolver conflitos', path:'/admin/disputas', bg:'#FFFBEB' },
            ].map((a,i)=>(
              <div key={i} onClick={()=>navigate(a.path)} style={{padding:'14px',borderRadius:'10px',cursor:'pointer',background:a.bg,border:'1px solid var(--border)',transition:'all 0.15s',textAlign:'center'}}
                onMouseOver={e=>{e.currentTarget.style.transform='translateY(-2px)';e.currentTarget.style.boxShadow='var(--shadow)';}}
                onMouseOut={e=>{e.currentTarget.style.transform='translateY(0)';e.currentTarget.style.boxShadow='none';}}>
                <div style={{marginBottom:'8px'}}>{a.icon}</div>
                <div style={{fontSize:'12px',fontWeight:'600',color:'var(--text-primary)',marginBottom:'2px'}}>{a.label}</div>
                <div style={{fontSize:'11px',color:'var(--text-muted)'}}>{a.sub}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}
